import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import AllSocialMedia from "../pages/dashboardPage/socialMediaSettings/allSocialMedia/AllSocialMedia";

// Tab id (permissionCatalog "social-media") → its page.
const TAB_PAGES = {
  "social-links": AllSocialMedia,
};

const SocialMediaNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("social-media", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default SocialMediaNavigator;
